import React from 'react';
import { I18n } from '@aws-amplify/core';
import { CloseOutlined } from '@ant-design/icons';
import { Row, Col, Typography } from 'antd';
import type { Gutter } from 'antd/lib/grid/row';
import * as S from './styles';

const { Title } = Typography;

interface DrawerProps {
	open: boolean;
	onSubmit?: () => void;
	onClose?: () => void;
	onClear?: () => void;
	title?: string;
	children: React.ReactNode;
	width?: number;
	gutter?: Gutter | [Gutter, Gutter];
	className?: string;
}

export function Drawer({
	open,
	onClose,
	onSubmit,
	onClear,
	title = '',
	children,
	width = 500,
	gutter,
	className
}: DrawerProps) {
	return (
		<S.DrawerWrapper
			className={className}
			title={
				<div>
					<Title level={3} style={{ margin: 0 }}>
						{title}
					</Title>
					<CloseOutlined className="close-icon" onClick={onClose} />
				</div>
			}
			placement="right"
			closable={false}
			onClose={onClose}
			open={open}
			width={width}
			footer={
				<Row justify="center" gutter={gutter}>
					{!onClear && (
						<Col>
							<S.OutlinedlButton onClick={onClose}>{I18n.get('Close')}</S.OutlinedlButton>
						</Col>
					)}
					{onClear && (
						<Col>
							<S.OutlinedlButton onClick={onClear}>{I18n.get('Clear')}</S.OutlinedlButton>
						</Col>
					)}
					{onSubmit && (
						<Col>
							<S.PrimaryButton onClick={onSubmit}>{I18n.get('Filter')}</S.PrimaryButton>
						</Col>
					)}
				</Row>
			}
		>
			{children}
		</S.DrawerWrapper>
	);
}
